module.exports = __webpack_public_path__ + "img/06.a6a6f1c1.jpg";